<template>
  <div class="rain-tank-monitor">
    <div class="caption pl-2 font-weight-bold">雨水タンク一覧表</div>
    <div class="d-flex align-center">
      <v-btn-toggle v-model="displayInterval" mandatory dense class="ma-2">
        <v-btn small :value="10">
          10分毎
        </v-btn>
        <v-btn small :value="60">
          時間毎
        </v-btn>
        <v-btn small :value="24">
          24時間毎
        </v-btn>
      </v-btn-toggle>
      <v-btn
        class="ml-3"
        :color="isAutoRefresh ? 'primary' : ''"
        @click="isAutoRefresh = !isAutoRefresh"
        small
      >
        自動更新 {{ isAutoRefresh ? "ON" : "OFF" }}
      </v-btn>
    </div>
    <v-card class="d-flex flex-wrap" tile flat color="transparent">
      <v-card
        v-for="(station, index) in stations"
        :key="station.id"
        class="pa-3 ma-2"
        width="560"
      >
        <div class="body-2">{{ index + 1 + ". " + station.name }}</div>
        <div class="d-flex">
          <v-card height="220" width="340" class="pa-2" outlined>
            <RainTankChart
              :height="200"
              :selected-observatory="station"
              :displayInterval="displayInterval"
            />
          </v-card>
          <div class="px-4 py-2">
            <div class="body-1 text-center mb-2">水位 {{ station.rate }}%</div>
            <div :style="chartStyle(station.rate)"></div>
          </div>
        </div>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import * as axiosHelper from "../utils/axiosHelper";
import { OBSERVATORY } from "@/enums/Type";
import RainTankChart from "@/components/base-map/details/RainTankChart";
import { RainTankTopLevel } from "../enums/Type";
import moment from "moment";
export default {
  name: "RainTankMonitor",
  components: {
    RainTankChart
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      stations: [],
      imageWindow: null,
      displayInterval: 24,
      isAutoRefresh: false,
      autoRefreshInterval: null
    };
  },

  watch: {
    isAutoRefresh(newValue) {
      if (this.autoRefreshInterval) {
        clearInterval(this.autoRefreshInterval);
        this.autoRefreshInterval = null;
      }
      const ms = 60 * 1000 * 10;
      if (newValue) {
        this.autoRefreshInterval = setInterval(() => {
          this.$store.commit("SET_BASE_DATE", moment.utc());
          this.sync();
        }, ms);
      }
    }
  },

  computed: {
    baseDate() {
      return this.$store.getters.baseDate;
    },
    rainTanks() {
      const observatories = this.$store.getters.observatories.filter(
        obs => obs.type === OBSERVATORY.RAINTANK.code
      );
      const targets = ["890_1", "890_2", "890_4", "890_5"];
      const priority = observatories.filter(obs => targets.includes(obs.id));
      const notPriority = observatories.filter(
        obs => !targets.includes(obs.id)
      );
      return priority.concat(notPriority);
    }
  },

  async created() {
    await this.$store.dispatch("FETCH_OBSERVATORIES");
    let date = moment.utc();
    if (this.$route.query.date) {
      date = moment.utc(this.$route.query.date, "YYYYMMDDHHmm");
      this.$router.replace({ path: this.$route.path, query: {} });
    }
    this.$store.commit("SET_BASE_DATE", date);
    this.sync();
  },

  methods: {
    chartStyle(rate) {
      const percentage = parseFloat(rate);
      if (isNaN(percentage)) {
        return { display: "none" };
      }
      const color = "#42a5f5";
      // if (percentage >= 90) {
      //   color = "#FF2800";
      // }
      return {
        width: "160px",
        height: "160px",
        background: `conic-gradient(${color} 0% ${percentage}%, #f2f2f2 ${percentage}% 100%)`,
        borderRadius: "50%"
      };
    },
    async sync() {
      const stations = [];
      const date2 = this.baseDate.clone();
      const date1 = this.baseDate.clone().subtract(14, "days");
      console.log("sync: " + this.baseDate.format("YYYY/MM/DD HH:mm"));
      const processes = this.rainTanks.map(target => {
        return (async () => {
          const row = { ...target };
          row.date = "";
          row.url = "";
          stations.push(row);
          const response = await axiosHelper.get("/observatories/reals", {
            type: target.type,
            id: target.id,
            date1: date1.format("YYYY/MM/DD HH:mm"),
            date2: date2.format("YYYY/MM/DD HH:mm"),
            dynamodb: target.dynamodb ? target.dynamodb : null
          });
          if (response !== null && response.reals) {
            const reals = response.reals;
            row.timeSeries = reals ? reals : [];
            const topLevel = RainTankTopLevel[target.id];
            const validReals = row.timeSeries.filter(r => r.level !== null);
            if (validReals.length > 0 && topLevel !== undefined) {
              const latest = validReals[validReals.length - 1];
              row.rate = Math.floor((latest.level / topLevel) * 100);
            }
          }
        })();
      });
      await Promise.all(processes);
      this.stations = stations;
    }
  }
};
</script>

<style lang="scss" scoped>
.rain-tank-monitor {
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
  padding: 4px;
  .station-area {
    background-color: white;
    padding: 8px 14px;
    cursor: pointer;
    border: 1px solid rgb(228, 228, 228);
  }
}
</style>
